import React, {useEffect, useState, createContext} from 'react';
import PropTypes from 'prop-types';
import {useLocation} from 'react-router-dom';

export const LocationContext = createContext(null);

const LocationInfo = ({children}) => {
  const location = useLocation();
  const [locationInfo, setLocationInfo] = useState({
    prevLocation: null,
    location
  });

  useEffect(() => {
    setLocationInfo(prevState => ({
      prevLocation: prevState.location,
      location
    }));
  }, [location]);

  return (
    <LocationContext.Provider value={{locationInfo}}>
      {children}
    </LocationContext.Provider>
  );
};
const propTypes = {
  children: PropTypes.any
};

LocationInfo.propTypes = propTypes;

export default LocationInfo;
